"use client"

import { Link as ChakraLink } from "@chakra-ui/react"
import NextLink from "next/link"

export default function NextChakraLink({ href, label, ...rest }) {
    return (
        <ChakraLink asChild {...rest}>
            <NextLink href={href}>{label}</NextLink>
        </ChakraLink>
    )
}
